const forms = [
  {
    name: "Task",
    className: "bg-white p-4 rounded-md p-8 w-[90%] mx-auto",
    options: [
      {
        name: "Image",
        type: "upload",
        form: {
          type: "text",
          name: "image",
          placeholder: "",
          class: "",
          value: "",
          required: false,
        },
      },
      {
        name: "Job",
        type: "selectandadd",
        path: "/app/projects/jobs/add/",
        form: {
          name: "project_job",
          allowClear: true,
          showSearch: true,
          filterOption: false,
          placeholder: "Task job",
          api: "",
          params: {
            api: "get-project-jobs",
            status: 1,
            project: "",
          },
          options: null,
          value: null,
          required: true,
        },
      },
      {
        name: "Name",
        type: "input",
        form: {
          type: "text",
          name: "name",
          placeholder: "Task name",
          class: "",
          value: "",
          required: true,
        },
      },
      {
        name: "Description",
        type: "input",
        form: {
          type: "text",
          name: "description",
          placeholder: "Task description",
          class: "",
          value: "",
          required: true,
        },
      },
      {
        name: "Number",
        type: "input",
        form: {
          type: "text",
          name: "number",
          placeholder: "Task number",
          class: "",
          value: "",
          required: false,
        },
      },
    ],
  },
  {
    name: "Status",
    options: [
      {
        name: "Task status",
        type: "select",
        form: {
          name: "task_status",
          allowClear: false,
          placeholder: "Task status",
          value: 0,
          options: [
            {
              value: 1,
              label: "Pending",
            },
            {
              value: 2,
              label: "Ongoing",
            },
            {
              value: 3,
              label: "Completed",
            },
            {
              value: 0,
              label: "Cancelled",
            },
          ],
          required: false,
        },
      },
      {
        name: "Status",
        type: "select",
        form: {
          name: "status",
          allowClear: false,
          placeholder: "Status",
          value: 1,
          options: [
            {
              value: 1,
              label: "Active",
            },
            {
              value: 0,
              label: "In-active",
            },
          ],
          required: false,
        },
      },
    ],
  },
];

export default forms;
